<script>
export default {
	name: 'LeafletGeoJson',
	inheritAttrs: false,
	props: {
		data: Object,
		polygonOptions: Object,
	},
	inject: {
		leaflet: 'leaflet',
		state: 'state',
		getLayer: { default: null }
	},
	data() {
		return {
			geoJson: null,
			rendered: false
		};
	},
	watch: {
		color() {
			this.rerender();
		},
		data: {
			handler() {
				this.rerender();
			}
		}
	},
	async created() {
		this.createGeoJson();
	},
	beforeDestroy() {
		if (this.state.map) {
			this.removeGeoJson();
			this.rendered = false;
		}
	},
	methods: {
		createGeoJson() {
			this.geoJson = this.leaflet.geoJSON(this.data);
		},
		removeGeoJson() {
			if (this.state.map && this.geoJson) {
				if (this.getLayer && this.getLayer() && this.getLayer().hasLayer(this.geoJson)) this.getLayer().removeLayer(this.geoJson);
				else if (this.state.map.hasLayer(this.geoJson)) this.geoJson.remove();
			}
		},
		rerender() {
			this.removeGeoJson();
			this.geoJson = null;
			this.createGeoJson();
			this.rendered = false;
		},
		getBounds() {
			return this.geoJson ? this.geoJson.getBounds() : null;
		},
	},
	render() {
		if (this.state.map && this.geoJson && !this.rendered) {
			this.geoJson.remove();
			if (this.getLayer && this.getLayer().addLayer) this.getLayer().addLayer(this.geoJson);
			else this.geoJson.addTo(this.state.map);
			this.geoJson.setStyle(this.polygonOptions);
			this.rendered = true;
		}
		return null;
	}
};
</script>

<style>
.leaflet-additional-line-style {
	cursor: grab !important;
}
.leaflet-additional-line-style:hover {
	cursor: grab !important;
}

</style>
